import classNames from 'classnames'
import { Link } from 'gatsby-link'
import React, { PropsWithChildren } from 'react'
import { isNullOrWhiteSpace } from '../../utilities/string'

export type DesktopListItemProps = {
  className?: string
  link?: string
  staticWidthClass?: string
}

export const DesktopListItem = ({
  children,
  className,
  link,
  staticWidthClass,
}: PropsWithChildren<DesktopListItemProps>) => (
  <span
    className={
      className ??
      classNames(
        staticWidthClass,
        {
          'flex-none': staticWidthClass,
          'flex-1': !staticWidthClass,
        },
        'mr-15 last:mr-0 text-secondary-darker font-t-light',
        'text-t-100',
        'md:text-t-200',
        'xl:text-t-400'
      )
    }
  >
    {!isNullOrWhiteSpace(link) ? (
      <Link
        className="text-primary font-medium transition-hover hover:opacity-hover"
        to={link}
      >
        {children}
      </Link>
    ) : (
      children
    )}
  </span>
)
